module.exports = __webpack_public_path__ + "img/bt.5d8bb188.svg";